module.exports = __webpack_public_path__ + "img/disco01.2bd611ee.jpg";